import { useTranslation } from 'react-i18next'
import { Box, Package, Truck, Wrench } from 'lucide-react'
import type { ArticleKind } from '../types/article.types'

const ART_FARBE: Record<ArticleKind, string> = {
  MATERIAL: 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-200',
  SERVICE: 'bg-violet-100 text-violet-800 dark:bg-violet-900/40 dark:text-violet-200',
  EQUIPMENT: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  OTHER: 'bg-muted text-muted-foreground',
}

const ART_SYMBOL = { MATERIAL: Package, SERVICE: Wrench, EQUIPMENT: Truck, OTHER: Box } as const

/** Die Artikelart als Kurzform mit Farbe (AP-28 9.1). */
export function ArtAbzeichen({ kind }: { kind: ArticleKind }) {
  const { t } = useTranslation()
  return (
    <span className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium ${ART_FARBE[kind]}`}>
      {t(`articles.kinds.${kind}`)}
    </span>
  )
}

/** Platzhalter für das Artikelbild — nach Art, solange keines hochgeladen ist. */
export function ArtSymbol({ kind, size = 16 }: { kind: ArticleKind; size?: number }) {
  const Symbol = ART_SYMBOL[kind]
  return <Symbol size={size} className="text-muted-foreground" aria-hidden />
}

/** Die beiden Rollen als Kürzel „V" / „E" — gesetzt ist gefüllt. */
export function RollenKuerzel({ sales, purchase }: { sales: boolean; purchase: boolean }) {
  const { t } = useTranslation()
  const kuerzel = (an: boolean, text: string, titel: string) => (
    <span
      title={titel}
      className={`inline-grid h-5 w-5 place-items-center rounded text-[0.68rem] font-bold ${
        an ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground'
      }`}
    >
      {text}
    </span>
  )
  return (
    <span className="inline-flex gap-1">
      {kuerzel(sales, t('articles.role.salesShort'), t('articles.role.sales'))}
      {kuerzel(purchase, t('articles.role.purchaseShort'), t('articles.role.purchase'))}
    </span>
  )
}
